export const LANGUAGE_LOADING = "LANGUAGE_LOADING";
export const LANGUAGE_ADD = "LANGUAGE_ADD";
export const LANGUAGE_DELETE = "LANGUAGE_DELETE";
export const LANGUAGE_LIST = "LANGUAGE_LIST";



// WEBPACK FOOTER //
// ./src/actions/language/types.js